import React from 'react';
import { JSONLD } from '../../../components/JSONLD';
import { ServiceLandingDownloadLinks } from '../../../constants';
import { createSchemaDownloadAction, createSchemaOrganization, createSchemaPerson, createSchemaService } from '../../../seo-schemas';
import { WalkerLocationV6, WalkerProfileV6 } from '../../../types/api';
type Props = {
  profile: WalkerProfileV6;
  location: WalkerLocationV6;
};

// TODO: update these services to come from the backend
const offeredServices = ['Dog Boarding', 'Dog Sitting', 'Dog Walking', 'Drop-In Visits', 'Dog Training'];
export const WalkerProfileSchemas = ({
  profile,
  location
}: Props) => {
  const schemaService = (serviceName: string) => createSchemaService({
    serviceType: serviceName,
    name: `${serviceName} service by ${profile.firstName}`,
    description: `${serviceName} service by ${profile.firstName}`,
    addressLocality: location.city,
    addressRegion: location.administrativeAreaLevel1,
    audienceDescription: `Pet parents who want ${serviceName} for their dog`,
    aggregateRating: profile.averageRating,
    provider: createSchemaPerson({
      name: profile.firstName,
      affiliation: 'Independent Contractor',
      description: profile.bio,
      potentialAction: 'Book'
    })
  });
  return <>
      <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="PCGProfileSchemas.tsx">
        {createSchemaOrganization()}
      </JSONLD>

      {offeredServices.map(serviceName => <JSONLD key={String(serviceName)}>
          {schemaService(serviceName)}
        </JSONLD>)}

      <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="PCGProfileSchemas.tsx">
        {createSchemaDownloadAction({
        description: 'Wag deeplink to download app or go to Overnight flow',
        target: ServiceLandingDownloadLinks.Overnight
      })}
      </JSONLD>

      <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="PCGProfileSchemas.tsx">
        {createSchemaDownloadAction({
        description: 'Wag deeplink to download app or go to Grooming flow',
        target: ServiceLandingDownloadLinks.Grooming
      })}
      </JSONLD>

      <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="PCGProfileSchemas.tsx">
        {createSchemaDownloadAction({
        description: 'Wag deeplink to download app or go to Training flow',
        target: ServiceLandingDownloadLinks.Training
      })}
      </JSONLD>

      <JSONLD data-sentry-element="JSONLD" data-sentry-source-file="PCGProfileSchemas.tsx">
        {createSchemaDownloadAction({
        description: 'Wag deeplink to download app or go to Walking flow',
        target: ServiceLandingDownloadLinks.Walking
      })}
      </JSONLD>
    </>;
};